import React, {useEffect, useRef, useState} from "react";
import {
    FaArrowRightArrowLeft,
    FaCopy,
    FaEllipsis,
    FaGrip,
    FaLayerGroup,
    FaPlus,
    FaThumbtack,
    FaTrash,
} from "react-icons/fa6";
import Button from "../../../components/button";

const MenuButton = ({icon: Icon, children, onClick, danger = false}) => (
    <Button
        type="button"
        onClick={onClick}
        target={danger ? "danger" : undefined}
        col={`w-full !h-8 !justify-start !rounded-none !border-0 !shadow-none !px-3 text-xs ${danger ? "" : "!bg-white hover:!bg-slate-100"}`}
    >
        <Icon className="w-3.5" /> {children}
    </Button>
);

const ListActionsMenu = ({list, lists, onAddCard, onCopy, onMove, onMoveCards, onTogglePin, onDelete}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [view, setView] = useState("actions");
    const wrapperRef = useRef(null);

    useEffect(() => {
        const close = event => {
            if (!wrapperRef.current?.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    const closeAfter = action => () => {
        action();
        setIsOpen(false);
        setView("actions");
    };

    return (
        <div ref={wrapperRef} className="relative">
            <Button
                type="button"
                onClick={() => setIsOpen(open => !open)}
                aria-label={`Ações da lista ${list.title}`}
                col="!h-7 !w-7 !border-0 !bg-transparent !p-0 !text-slate-400 !shadow-none hover:!bg-slate-200 hover:!text-slate-600"
            >
                <FaEllipsis />
            </Button>

            {isOpen && (
                <div className="absolute right-0 top-9 z-40 w-64 overflow-hidden rounded-lg border border-slate-200 bg-white py-1 shadow-xl">
                    <div className="border-b border-slate-100 px-3 py-2 text-xs font-bold text-slate-700">
                        {view === "actions" ? "Ações da lista" : view === "move" ? "Mover lista" : "Mover cartões"}
                    </div>

                    {view === "actions" && <>
                        <MenuButton icon={FaPlus} onClick={closeAfter(onAddCard)}>Adicionar cartão</MenuButton>
                        <MenuButton icon={FaCopy} onClick={closeAfter(onCopy)}>Copiar lista</MenuButton>
                        <MenuButton icon={FaGrip} onClick={() => setView("move")}>Mover lista</MenuButton>
                        <MenuButton icon={FaArrowRightArrowLeft} onClick={() => setView("cards")}>Mover todos os cartões</MenuButton>
                        <MenuButton icon={FaThumbtack} onClick={closeAfter(onTogglePin)}>{list.pinned ? "Desafixar lista" : "Fixar lista"}</MenuButton>
                        <div className="my-1 border-t border-slate-100" />
                        <MenuButton icon={FaTrash} danger onClick={closeAfter(onDelete)}>Excluir lista</MenuButton>
                    </>}

                    {view === "move" && (
                        <div className="p-2">
                            <p className="px-1 pb-2 text-[11px] text-slate-400">Escolha a nova posição:</p>
                            <div className="grid grid-cols-4 gap-1">
                                {lists.map((target, index) => (
                                    <Button key={target.id} type="button" disabled={target.id === list.id} onClick={closeAfter(() => onMove(index))} col="!h-8 !px-2 text-xs">
                                        {index + 1}
                                    </Button>
                                ))}
                            </div>
                            <Button type="button" onClick={() => setView("actions")} col="mt-2 !h-7 !border-0 !shadow-none !px-1 text-xs text-blue-600">Voltar</Button>
                        </div>
                    )}

                    {view === "cards" && (
                        <div className="p-1">
                            {lists.filter(target => target.id !== list.id).map(target => (
                                <MenuButton key={target.id} icon={FaLayerGroup} onClick={closeAfter(() => onMoveCards(target.id))}>{target.title}</MenuButton>
                            ))}
                            {lists.length === 1 && <p className="p-3 text-xs text-slate-400">Crie outra lista para mover os cartões.</p>}
                            <Button type="button" onClick={() => setView("actions")} col="!h-7 !border-0 !shadow-none !px-3 text-xs text-blue-600">Voltar</Button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ListActionsMenu;
